export default __webpack_public_path__ + "static/screenshot-identity-b0c1ca751949d03d85c3f3aaacea8adc.png";